import { PRODUCTION_ORIGIN } from "lib/seo";
import SchemaSet from "./schema-set";

// Entity identity is backed by the live site and Shopify's partner directory.
// Do not add reviews, awards, offices or commercial results without source evidence.
const SiteSchema = () => {
  const origin = PRODUCTION_ORIGIN;
  return (
    <SchemaSet schemaData={{
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${origin}/#organization`,
          name: "DigiFist",
          url: `${origin}/`,
          description: "Shopify Premier Partner providing Shopify development, migrations and e-commerce services.",
          sameAs: ["https://www.shopify.com/partners/directory/partner/digifist"],
        },
        {
          "@type": "WebSite",
          "@id": `${origin}/#website`,
          name: "DigiFist",
          url: `${origin}/`,
          publisher: { "@id": `${origin}/#organization` },
        },
      ],
    }} />
  );
};

export default SiteSchema;
